import React from 'react';
import type { FC } from 'react';
import { di } from 'react-magnetic-di';
import { useFragment } from 'react-relay';
import { graphql } from 'relay-runtime';
import { PortalCard } from 'view/help-center/portal-card';
import { useIsPageInEditMode } from 'view/layout-next/controllers';
import { removeHyperlinks } from '@atlassian/help-center-common-util/parse';
import type { portal_HelpCenterPortal$key as HelpCenterPortal } from './__generated__/portal_HelpCenterPortal.graphql';

export const Portal: FC<{ portal: HelpCenterPortal }> = ({ portal }) => {
    di(useIsPageInEditMode);
    const [isPageInEditMode] = useIsPageInEditMode();
    const { name, description, logo, portalId } = useFragment<HelpCenterPortal>(
        graphql`
            fragment portal_HelpCenterPortal on HelpLayoutPortalCard {
                name @required(action: THROW)
                description
                logo
                portalId
            }
        `,
        portal
    );
    let descriptionToRender = description?.toString();
    if (isPageInEditMode && !!descriptionToRender) {
        descriptionToRender = removeHyperlinks(descriptionToRender);
    }

    return (
        <PortalCard
            portalName={name}
            description={descriptionToRender}
            portalUrl={`/portal/${Number(portalId)}`}
            iconUrl={logo ?? undefined}
            id={Number(portalId)}
        />
    );
};
